import { OmsTotalsType } from './paymentSuccess/@types';

/**
 *
 * @param data CartTotalsType
 * @description transform order totals from cart
 * @returns transformed totals
 */

export const totalsTransformer = (data: CartTotalsType) => ({
  bagTotal : data.bagtotal,
  subTotal : data.subtotal,
  bagDiscount : data.bagdiscount,
  discount : data.discount,
  totalSaved : data.totalsaved,
  grandTotal : data.grandtotal,
  grandTotalNoTax : data.grandtotal_no_tax,
  orderRewardPoints : data.order_rewardpoints,
  shipping : data.shipping || 0,
  tax : data.tax || 0,
});

/**
 *
 * @param data OmsTotalsType
 * @description transform order totals from OmsApi
 * @returns transformed totals
 */

export const omsTotalsTransformer = (data: OmsTotalsType) => ({
  bagTotal : data.totalMrp,
  subTotal : data.subTotal,
  bagDiscount : data.bagDiscount,
  discount : data.discount,
  totalSaved : data.totalSaved,
  grandTotal : data.grandTotal,
  grandTotalNoTax : data.grandtotal_no_tax,
  orderRewardPoints : data.order_rewardpoints,
  shippingCharges : data.shippingCharges || 0,
  tax : data.tax || 0,
  giftCardAmount : data.giftCardAmount || 0,
  otherPayments : data.otherPayments || 0,
  walletAmount : data.walletAmount || 0,
  codCharges: data.codCharges || {},
});
